import { STATE_PROP } from '../util/constant';

export const selectReducer = (state) => state[STATE_PROP];

export const selectMachineDetailsInformationInfo = (state) =>
  selectReducer(state) ? selectReducer(state).get('machineInformation') : {};

export const selectMachineSuggestions = (state) =>
  selectReducer(state) ? selectReducer(state).get('machineSuggestions') : {};

export const updatedAliasMachineDetailsInfo = (state) =>
  selectReducer(state) ? selectReducer(state).get('machineAlias') : {};

export const updatedFacilityMachineDetailsInfo = (state) =>
  selectReducer(state) ? selectReducer(state).get('organisation') : {};

export const updatedObjectMachineDetailsInfo = (state) =>
  selectReducer(state) ? selectReducer(state).get('object') : {};

export const machineDeletionInfo = (state) =>
  selectReducer(state) ? selectReducer(state).get('delete') : {};

export const selectUpdateGeofenceInfo = (state) =>
  selectReducer(state) ? selectReducer(state).get('updateGeofence') : {};
